import { memo, useEffect } from "react";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";
import { useParams } from "react-router-dom";
import type { PurchaseParamsT } from "../../../../models/models";
import useCurrency from "../../../../hooks/useCurrency";
import { CurrencySymbolE } from "../../../../models/enums";
import useCouponCode from "../../../../hooks/useCouponCode";
import usePurchases from "../../../../hooks/usePurchases";
import { useUser } from "../../../../../../../contexts/userContext/userContext";
import LoadingImageElement from "../../../../../../Elements/LoadingContainerElement/LoadingImageElement";

import styles from "./styles.module.scss";

const SubscriptionPriceDetails = memo(() => {
  const { packageType, periodType } = useParams<PurchaseParamsT>();
  const { getTextByKey } = useContent();
  const { currency } = useCurrency();
  const { couponCode, selectedPlanPriceWithDiscount } = useCouponCode();
  const {
    selectedPlanPrice,
    purchasePrice,
    fetchPurchasePrice,
    isFetchingPurchasePrice,
  } = usePurchases();
  const { getUserBillingDetails } = useUser();

  useEffect(() => {
    fetchPurchasePrice(packageType!);
  }, []);

  return (
    <div className={styles.purchaseDetailsSubscription}>
      {!isFetchingPurchasePrice ? (
        <div className={styles.purchaseDetailsContainer}>
          <div className={styles.subscriptionTitle}>
            {getTextByKey(`${packageType}-${periodType}-subscription`)}
          </div>
          {couponCode.status === "validated" && couponCode.isValid ? (
            <div className={styles.purchaseDetailsDiscount}>
              <div className={styles.purchaseDetailsDiscountText}>
                {getTextByKey("purchase-after-discount")}
              </div>
              {selectedPlanPriceWithDiscount ? (
                <div className={styles.purchaseDetailsDiscountValue}>
                  {CurrencySymbolE[currency]}{" "}
                  {parseFloat(selectedPlanPriceWithDiscount + "")?.toFixed(2)}
                </div>
              ) : null}
            </div>
          ) : null}
          {/* In case you need to pay less (UPGRADE) */}
          {purchasePrice < selectedPlanPrice! ? (
            <div className={styles.purchaseDetailsDiscount}>
              <div className={styles.purchaseDetailsDiscountText}>
                {getTextByKey("purchase-per-today")}
              </div>
              <div className={styles.purchaseDetailsDiscountValue}>
                {CurrencySymbolE[currency]}{" "}
                {parseFloat(purchasePrice + "")?.toFixed(2)}
              </div>
            </div>
          ) : null}
          <div className={styles.purchaseDetailsCycle}>
            <div className={styles.purchaseCycleText}>
              {getTextByKey(
                getUserBillingDetails() || couponCode.isValid
                  ? "next-billing-price"
                  : "current-billing-price"
              )}
            </div>
            <div className={styles.purchaseCyclePrice}>
              {CurrencySymbolE[currency] +
                " " +
                parseFloat(selectedPlanPrice + "")?.toFixed(2) +
                " / " +
                getTextByKey(
                  `short-${periodType === "yearly" ? "year" : "month"}-letter`
                )}
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.purchaseDetailsContainer}>
          <div className={styles.subscriptionTitle}>
            {getTextByKey(`${packageType}-${periodType}-subscription`)}
          </div>
          <LoadingImageElement />
        </div>
      )}
    </div>
  );
});

export default SubscriptionPriceDetails;
